import { Donor } from "../models";

export const serologyFieldsFirstColumn = ["hbcab", "hbsag", "hcvab", "rpr", "hbvNat", "hcv", "hiv12Nat", "hivPlusOAb"];

export const serologyFieldsSecondColumn = ["htlv", "cmv", "ebv", "wnv", "toxo", "captia", "tpha", "aborh"];

export const allSerologyFields = [...serologyFieldsFirstColumn, ...serologyFieldsSecondColumn];

export const getIsSerologiesFinal = (donor: Donor | undefined) => {
    const serologies = donor?.serologies?.data;
    if (!serologies) return false;

    const isNotRun = (result: string) => result === "not-run";
    const isPending = (result: string) => result === "pending";
    const isBlank = (result: string) => !result;

    const isSerologyValid = (result: string) => {
        if (isNotRun(result)) return true;
        if (isPending(result)) return false;
        if (isBlank(result)) return false;
        return true;
    };

    const serologyFields = [...allSerologyFields];

    if (serologies.testName1) serologyFields.push("result1");
    if (serologies.testName2) serologyFields.push("result2");

    return serologyFields.every((field) => isSerologyValid(serologies[field]));
};
